import { PageElement } from "@easy-email-pro-core/typings";
import type { JsonToMjmlOption } from "@easy-email-pro-core/utils/isProductionMode";
import React, { useContext, useMemo } from "react";
import { EditorCore } from "..";

export type EmailRenderInputProps = {
  mode: JsonToMjmlOption["mode"];
  context: { content: PageElement };
  displayMode?: "desktop-mobile" | "only-desktop" | "only-mobile";
  universalElements: JsonToMjmlOption["universalElements"];
  keepEmptyAttributes: boolean;
  mergetagsData?: Record<string, any>;
  attributesVariables?: Record<string, any>;
  variablesDisabled?: boolean;
};

export type EmailRenderProps = EmailRenderInputProps & {
  pageVariables: Record<string, any>;
};

const EmailRenderContext = React.createContext<EmailRenderProps>({} as any);

export const useEmailRenderContext = () => {
  return useContext(EmailRenderContext);
};

export const EmailRenderProvider: React.FC<
  EmailRenderInputProps & { children: React.ReactNode }
> = (props) => {
  const adapterProps = useMemo(() => {
    const pageVariables = EditorCore.getPageDataVariables(
      props.context.content.data.variables,
      props.attributesVariables || {}
    );
    return {
      ...props,
      pageVariables,
    };
  }, [props]);

  return (
    <EmailRenderContext.Provider value={adapterProps}>
      {props.children}
    </EmailRenderContext.Provider>
  );
};
